import {isMobile, isTablet} from "../helpers";
import {gsap} from "gsap";

export function initHeaders() {
    const titles = gsap.utils.toArray('.archive-title');
    const titlesLength = titles.length;
    const percent = 100 / titlesLength;

    titles.forEach((item, index) => {
        let x = +$(item).attr('data-item') || 0;
        /*let x = (index + 1) * 80;*/

        gsap.timeline({
            scrollTrigger: {
                trigger: item,
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: `top-=110% bottom`,
                end: `bottom-=130% top`,
                scrub: 0.8,
            },
        }).from($(item), {
            ease: "none",
            x: `${x}%`,
            willChange: 'transform',
        })
    })
}
